import { Box, Container, CssBaseline, styled } from "@mui/material"
import { FC, ReactNode } from "react"
import { selectImpersonateMessage } from "src/features/profile"

import { MainAppbar } from "./MainAppbar"
import { appConstants } from "../appConstants"
import { useAppSelector } from "../hooks/hooks"

const StyledContentContainer = styled(Container)(({ theme }) => ({
  // display: "flex",
  paddingTop: "10px",
  paddingBottom: "10px",
  width: `100%`,
  marginTop: `${appConstants.mainAppBarHeight}px`,
  height: `calc(100vh - ${appConstants.mainAppBarHeight}px)`,
  overflowY: "auto",
}))

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const impersonateMessage = useAppSelector(selectImpersonateMessage)
  return (
    <Box>
      <CssBaseline />
      <MainAppbar />
      <StyledContentContainer maxWidth={false}>
        {impersonateMessage && (
          <Box
            sx={{
              backgroundColor: "warning.main",
              color: "white",
              padding: "10px",
              textAlign: "center",
            }}
          >
            {impersonateMessage}
          </Box>
        )}
        {children}
      </StyledContentContainer>
    </Box>
  )
}
